function toTitle(key, overrides = {}) {
  if (overrides[key]) return overrides[key];

  const lowercaseWords = [
    "of",
    "and",
    "the",
    "in",
    "on",
    "at",
    "by",
    "for",
    "to",
    "with",
    "from",
  ];

  return (
    key
      // Insert space between camelCase parts
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      // Uppercase acronyms at the start (1–3 lowercase letters)
      .replace(/^([a-z]{1,3})\b/, (match) => match.toUpperCase())
      // Split into words and title-case smartly
      .split(" ")
      .map((word, index) => {
        const lower = word.toLowerCase();
        if (index !== 0 && lowercaseWords.includes(lower)) {
          return lower;
        }
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      })
      .join(" ")
  );
}
export { toTitle };

// toTitle("artOfSchool");        // Art of School
// toTitle("schoolOfDrama");      // School of Drama
// toTitle("theEndOfTime");       // The End of Time
// toTitle("hrName");             // HR Name
// toTitle("urlPath");            // URL Path
// toTitle("employeeId", { employeeId: "Employee ID" }); // Employee ID
